import type { CeoProjectHealthItem } from '@shared/api';
import { Badge } from '@shared/ui/Badge';
import { formatMillions } from '../ceoFormat';
import {
  Section,
  SectionHeader,
  SectionLink,
  SectionTitle,
  Table,
  TableWrap,
} from './styles';

interface ProjectsHealthSectionProps {
  projects: CeoProjectHealthItem[];
}

export function ProjectsHealthSection({ projects }: ProjectsHealthSectionProps) {
  if (projects.length === 0) return null;

  return (
    <Section>
      <SectionHeader>
        <SectionTitle>Матрица финансового и договорного здоровья объектов</SectionTitle>
        <SectionLink to="/agents/progress">Открыть ОСНОВА.Руководитель →</SectionLink>
      </SectionHeader>
      <TableWrap>
        <Table>
          <thead>
            <tr>
              <th>Объект строительства</th>
              <th>Заказчик</th>
              <th>План БДДС</th>
              <th>Ожидается по КС-3</th>
              <th>Факт поступлений</th>
              <th>Кассовая дебиторка</th>
              <th>Претензии / Поручения</th>
              <th>Индикатор</th>
            </tr>
          </thead>
          <tbody>
            {projects.map((p) => (
              <tr key={p.project_name}>
                <td>
                  <strong>{p.project_name}</strong>
                </td>
                <td>{p.customer_name}</td>
                <td>{formatMillions(p.bdds_planned)}</td>
                <td>{formatMillions(p.expected_net_inflow)}</td>
                <td>{formatMillions(p.actual_received)}</td>
                <td>{formatMillions(p.receivable_gap)}</td>
                <td>
                  Претензий: {p.active_claims_count} · Просроч. поручений:{' '}
                  {p.overdue_instructions_count}
                </td>
                <td>
                  <Badge
                    $tone={
                      p.health_status === 'good'
                        ? 'success'
                        : p.health_status === 'critical'
                          ? 'danger'
                          : 'warning'
                    }
                  >
                    {p.health_status === 'good'
                      ? 'В графике'
                      : p.health_status === 'critical'
                        ? 'Критично'
                        : 'Требует контроля'}
                  </Badge>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </TableWrap>
    </Section>
  );
}
